import type { LngLatBoundsLike } from "maplibre-gl";

/**
 * Default extent — the whole of Kazakhstan (brief §5.2). Values are
 * [west, south, east, north] and match the boundary dataset's own extent
 * (46.5..87.4 E, 40.5..55.5 N).
 */
export const KZ_BOUNDS: LngLatBoundsLike = [
  [46.5, 40.5],
  [87.4, 55.5],
];

export const KZ_FIT_PADDING = 32;
